/**
 * Is used to identify communication fields within the components to set their visibilities and display errors.
 */
export enum CommunicationField {
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  MOBILE_PHONE = 'MOBILE_PHONE',
}
